import { postJson } from '@/lib/apiConfig';

export interface SubmitCsatPayload {
  pedido_id: number;
  score: number;
  comment?: string;
  channel?: string;
  cliente?: string;
  empresa?: string;
  metadata?: Record<string, unknown>;
}

/** Persiste avaliação CSAT após finalização do orçamento (grupo API `backoffice`). */
export async function submitCsatResponse(payload: SubmitCsatPayload) {
  const comment = payload.comment?.trim() ?? '';
  const cliente = payload.cliente?.trim() || undefined;
  const empresa = payload.empresa?.trim() || undefined;

  return postJson('backoffice', 'csat/responses', {
    pedido_id: payload.pedido_id,
    score: payload.score,
    comment,
    channel: payload.channel || 'portal-checkout',
    ...(cliente ? { cliente, customer_name: cliente } : {}),
    ...(empresa ? { empresa, company_name: empresa } : {}),
    metadata: payload.metadata ?? {
      source: 'portal-checkout',
      submitted_at: new Date().toISOString(),
    },
  });
}
